export default "__VITE_ASSET__55b168ca__"